NHS.Scripts.HomeDetailXp = function (parameters) {
  //Initializing parameters
  this.parameters = parameters;
  this.saveHomeMethod = parameters.saveHomeMethod;
  this.logger = new NHS.Scripts.Globals.EventLogger({
    parentCommunityId: parameters.parentCommunityId,
    siteRoot: parameters.logInfo.siteRoot,
    fromPage: parameters.logInfo.fromPage,
    partnerID: parameters.logInfo.partnerId,
    partnerName: parameters.logInfo.partnerName,
    performanceLogUrl: parameters.logInfo.performanceLogUrl,
    marketId: parameters.marketId
  });
  this.favs = new NHS.Scripts.Favorites({
    urlBase: parameters.urlBase,
    partnerId: parameters.PartnerId,
    marketId: parameters.MarketId,
    logInfo: parameters.logInfo
  });
};

NHS.Scripts.HomeDetailXp.prototype = {
  initialize: function () {
    var self = this;

    /**
     * Lazy loads ratings and reviews component, and only if the builder has reviews
     */
    const loadReviews = function() {
      const ratingsFlagElement = document.querySelector('#IsReviewsAvailable');
      const hasReviews = ratingsFlagElement && ratingsFlagElement.value === 'True';

      if (hasReviews) {
        const microModalInput = document.querySelector('#ratings-bundle');

        NHS.loadJs(microModalInput.value, "ratings-script", function () {
          RatingsAndReviews.loadDetailSection();
        });
      }
    }

    var attributeParameters = self.parameters;
    if (attributeParameters.mapParameters) {
      attributeParameters.mapParameters.logger = new NHS.Scripts.Globals.EventLogger({
        siteRoot: self.parameters.logInfo.siteRoot,
        partnerId: self.parameters.logInfo.partnerId,
        partnerName: self.parameters.logInfo.partnerName,
        marketId: self.parameters.logInfo.marketId,
        performanceLogUrl: self.parameters.logInfo.performanceLogUrl
      });
    }

    self.favs.init();

    // Create the interactive map
    var mapsContainer = document.querySelector("#nhs_PropertyMap");
    self.googlePropertyMap = new NHS.Scripts.GooglePropertyMap(attributeParameters.mapParameters);
    self.googlePropertyMap.SetUpdate();

    function loadInteractiveMap(event) {
      self.googlePropertyMap.init();
      mapsContainer.removeEventListener("click", loadInteractiveMap);
    }

    if (mapsContainer) {
      mapsContainer.addEventListener("click", loadInteractiveMap);
    }

    var propertyId = self.parameters.isSpec ? self.parameters.specId : self.parameters.planId;
    function attachTrackingEvents() {

      // Request and appointment
      var appoinmentButtons = document.querySelectorAll("#btn_NhsMapSend");
      for (var i = 0; i < appoinmentButtons.length; i++) {
        var button = appoinmentButtons[i];

        button.addEventListener("click", function () {
          jQuery.googlepush('Home Detail Events', 'Request An Appointment button', propertyId, 2, false);
        });
      }

      // Tab switching
      var tabsContainer = document.querySelector(".map__tabs");
      if (tabsContainer) {
        tabsContainer.addEventListener("click", function () {
          jQuery.googlepush('Home Detail Events', 'Map - Tab', propertyId, 2, false);
        });
      }
    }

    attachTrackingEvents();

    jQuery("body").on("click", "a[href=#top]", function () {
      jQuery("html, body").animate({
        scrollTop: 0
      }, "slow");
      return false;
    });

    function downLoadFloorPlanOptionsModule() {
      const jsInput = document.getElementById('floorPlanOptionsJavascriptUrl');
      const checkBox = this;
      if (jsInput) {
        NHS.loadJs(jsInput.value, 'floorPlanOptionsScript', function () {
          const floorPlanOptionsContainer = document.querySelector('[data-floor-plan-options-container]');
          if (floorPlanOptionsContainer) {
            floorPlanOptionsContainer.setAttribute('data-floor-plan-container', true);
            checkBox.dispatchEvent(new Event('click'));
          }
        });
        jsInput.remove();
      }
    }

    // Floorplan Options Section
    if (this.parameters.showfloorsection) {
      var url;
      if (this.parameters.floorPlanActionUrl.indexOf("planid") !== -1) {
        url = this.parameters.floorPlanActionUrl.replace("{planid}", this.parameters.planId);
      } else {
        url = this.parameters.floorPlanActionUrl.replace("{specid}", this.parameters.specId);
      }
      jQuery.ajax({
        type: "POST",
        url: url,
        data: JSON.stringify(self.parameters.floorplanOptionsViewModel),
        contentType: 'application/json',
        success: function (data) {
          jQuery("#nhs_FloorPlanAreaSection").html(data);
          const checkBoxesElements = document.querySelectorAll('[data-floor-plan-option="true"]');
          for (let i = 0; i < checkBoxesElements.length; i += 1) {
            checkBoxesElements[i].addEventListener('click', downLoadFloorPlanOptionsModule);
          }
        }
      });
    }

    const mapButton = document.querySelector('.nhs_FormMapLink');
    if (mapButton) {
      mapButton.addEventListener('click', (event) => {
        event.preventDefault();
        const neighborhoodStickyButton = document.querySelector('[data-id="nhs_MapsAndDirections"]');
        if (neighborhoodStickyButton) {
          neighborhoodStickyButton.click();
        }
      });
    }

    self._updateAdsPosition();

    const nearbyWrapper = document.querySelector('[data-nearby-wrapper]');
    if (nearbyWrapper !== null) {
      self.performLazyLoad('nhs_nearbyHomesSection', null, nearbyWrapper.dataset.url, function (data) {
        if (!data) {
          const nearbySection = document.querySelector('[data-nearby-section]');
          nearbySection.setAttribute('hidden', '');
          return;
        }
        
        document.querySelector('[data-nearby-wrapper]').innerHTML = data;
        self.favs.init();
      });
    }

    loadReviews();

    new window.NewHomeSource.Modules.ArrowHandler({
      container: document.querySelector('[data-toolbar]')
    });

    // Arrow Handler for Sticky Bar
    new window.NewHomeSource.Modules.ArrowHandler({
      container: document.querySelector('[data-sticky-bar]')
    });

    //Click for Saving Home
    jQuery(document).on("click", "span#nhs_SaveThisItem, span.nhs_Save.nhs_Saved, a.nhs_ItemSaved", function () {
      jQuery.post(self.parameters.removeHomeMethod, {
        builderId: self.parameters.builderId
      }, (function (json) {
        self.ShowSuccessMessage(json);
        jQuery("p #nhs_NextStepsSaveThisItem").removeClass("nhs_ItemSaved").text(self.parameters.SaveToFavoritesText);
        jQuery("#nhs_NextStepsSaveThisItem").on("click", function (event) {
          if (!jQuery(this).is(".nhs_ItemSaved")) {
            self.SaveHome(true);
            event.stopImmediatePropagation();
          }
        });
      }).bind(this), "json");
    });

    var container = document.querySelector("#nhs_DetailSalesOffice [data-slider-component]");

    /**
     * trackReadMoreOfferEvent: tracks the event when the read more button is clicked.
     * @param {string} readMoreButtonText word that is used on the read more button.
     */
    function trackReadMoreOfferEvent(readMoreButtonText){
      const googleAnalyticsEvent = {
        eventType: 'GA4Event',
        eventName: 'builder_deals',
        params: {
          click_target: readMoreButtonText
        }
      };
      document.body.dispatchEvent(new CustomEvent('trackOnDemandEvent', {
        detail: { data: googleAnalyticsEvent }
      }));
    }

    //Offers Click Listener
    var readOffersContainer = document.querySelector("[data-offersContainer]");
    if (readOffersContainer) {
      var offerBubblesCollection = document.querySelectorAll("[data-offerBubble]");
      var currentReadMoreText = "";
      var showHiddenContentClass = "offer__show";
      var showMoreElement;
      var collapsibleContentElement;
      readOffersContainer.addEventListener("click", function (event) {
        //If read more, we should change the text
        if (event.target.hasAttribute("data-readMoreOffer")) {
          for (var counter = 0; counter < offerBubblesCollection.length; counter++) {
            collapsibleContentElement = offerBubblesCollection[counter].querySelector("[data-collapsedContent]")
            if (collapsibleContentElement) {
              if (collapsibleContentElement.classList.contains(showHiddenContentClass)) {
                collapsibleContentElement.classList.remove(showHiddenContentClass);
              } else {
                collapsibleContentElement.classList.add(showHiddenContentClass);
              }
            }

            showMoreElement = offerBubblesCollection[counter].querySelector("[data-readMoreOffer]");
            if (showMoreElement) {
              currentReadMoreText = showMoreElement.textContent;
              showMoreElement.textContent = showMoreElement.getAttribute("data-toggleText");
              showMoreElement.setAttribute("data-toggleText", currentReadMoreText);

              const currentEventReadMoreText = showMoreElement.dataset.eventCurrentText;
              const currentEventReadMoreToggleText = showMoreElement.dataset.eventToggleText;
              showMoreElement.dataset.eventCurrentText = currentEventReadMoreToggleText;
              showMoreElement.dataset.eventToggleText = currentEventReadMoreText;
              trackReadMoreOfferEvent(currentEventReadMoreText);
            }

          }
        }
      });
    }
    self.googleAnalyticsBindings();

    //sticky bar detail pages scroll
    var scrollToBarItems = document.querySelectorAll('[page-scroller]');
    var scrollBehavior = 'scrollBehavior' in document.documentElement.style;
    for (var i = 0; i < scrollToBarItems.length; i++) {
      scrollToBarItems[i].addEventListener("click", function (event) {
        if (window.scroll) {
          event.preventDefault();
          var target = document.getElementById(this.getAttribute("data-target"));
          var selectedTab = document.querySelector("[class*=nhs-n1-c-button--tab-light-active]");
          if (target) {
            if (scrollBehavior) {
              target.scrollIntoView({ behavior: "smooth" });
            } else {
              target.scrollIntoView();
            }
            var targetElement = event.target;
            if (selectedTab && targetElement.hasAttribute("data-sticky-tab")) {
              selectedTab.classList.remove("nhs-n1-c-button--tab-light-active");
              delete selectedTab.dataset.itemActive;
              targetElement.classList.add("nhs-n1-c-button--tab-light-active");
              targetElement.dataset.itemActive = 'true';
            }
          }

        }
      });
    }

    const similarHomesContainer = document.querySelector('#nhs_HomeCarousel');
    if (similarHomesContainer) {
      similarHomesContainer.addEventListener('sectionLazyLoaded', (event) => {
        self.favs.init();
      });
    }
  },
  selectFloorPlanType: function (elem) {
    if (elem.classList.contains("nhs_ViewFloorPlan")) {
      document.querySelector(".bxslider li [data-type='FLP']").click();
    }
    if (elem.classList.contains("nhs_ViewInteractiveFloorPlan")) {
      document.querySelector(".bxslider li [data-type='IFP']").click();
    }
  },

  performLazyLoad: function (idOfVisibleElement, dataForAjax, urlForAjax, successAjaxFunction) {
    var lazyLoadReady = false;
    var visibleElement = document.querySelector("#" + idOfVisibleElement);
    var dataLazyLoadMapAndDirections = {
      ElementVisibleId: idOfVisibleElement,
      UpdateAction: function () {
        var isVisible = false;

        if (visibleElement) {
          isVisible = visibleElement.childNodes.length > 0;
        }

        if ((isVisible && lazyLoadReady) === false) {
          lazyLoadReady = true;
          jQuery.ajax({
            url: urlForAjax,
            type: dataForAjax !== null ? "POST" : "GET",
            contentType: 'application/json',
            data: JSON.stringify(dataForAjax),
            success: successAjaxFunction
          });
        }
      }
    };
    jQuery.LazyLoad(dataLazyLoadMapAndDirections);
  },

  googleAnalyticsBindings: function () {
    jQuery(document).on('mousedown', 'a.btn_MoreInfo', function (event) {
      NHS.Scripts.Helper.createCookie("CTAName", "Home - Request More Information - CTA - Submit");

      jQuery.googlepush("Lead Events", 'Home - Request More Information - CTA - Modal Open', "Request More Info");
    });
  },

  SaveHome: function (isNextStepsSaveClick) {
    var self = this;

    jQuery.post(self.saveHomeMethod, {
      builderId: self.parameters.builderId
    }, (function (json) {
      self.ShowSuccessMessage(json);
      if (json.data) {
        jQuery("#nhs_NextStepsSaveThisItem").removeAttr("onclick");
        jQuery("#nhs_NextStepsSaveThisItem").removeAttr("href");
        jQuery("#liSaveToPlanner").html('<span id=\"nhs_SaveThisItem\">' + self.parameters.SavedText + "</span>");
        jQuery("a#nhs_Saved").replaceWith("<span class='nhs_Save nhs_Saved'>" + self.parameters.SavedText + "</span>");
        jQuery("p #nhs_NextStepsSaveThisItem").addClass("nhs_ItemSaved").text(self.parameters.SavedText).removeAttr("onclick").removeAttr("href");

      }
    }).bind(this), "json");
    logger.logEventWithParameters((isNextStepsSaveClick ? self.parameters.NextStepsClickSave : "HOMSTC"), self.parameters.logInfo);
  },
  NextStepsSaveHome: function () {
    var self = this;
    if (!jQuery(this).is(".nhs_ItemSaved"))
      self.SaveHome(true);
  },

  ShowSuccessMessage: function (json) {
    var self = this;
    if (!json.data) {
      window.location.href = json.redirectUrl;
    } else {
      if (json.message === self.parameters.saveMessage) {
        //jQuery("#nhs_SaveThisItem").hide();
        jQuery("a#nhs_SaveThisItem").replaceWith("<a><span id='nhs_SaveThisItem'>" + self.parameters.SavedToYourProfileText + "</span></a>");
        jQuery("#SuccessMessage").show();
        //RemoveHome();
      } else {
        self = this;
        jQuery("span#nhs_SaveThisItem").replaceWith("<a id='nhs_SaveThisItem'>" + self.parameters.SaveToFavoritesText + "</a>");
        jQuery("span.nhs_Save.nhs_Saved").replaceWith("<a id='nhs_Saved' class='nhs_Save' title='Save'>Save</a>");
        jQuery("a#nhs_SaveThisItem, a.nhs_Save").on("click", function () {
          self.SaveHome();
        });
      }
    }
  },

  _updateAdsPosition: function () {
    var detailInfo = document.querySelector(".nhs_DetailMain:not(.nhs_First)");
    var adCol = document.querySelector("#nhs_AdColumn");
    var container = adCol.querySelector("div");

    if (!detailInfo || !adCol || !container || typeof window.MutationObserver === "undefined") return;

    container.setAttribute("style", "position: -webkit-sticky; position: sticky; top: 0; right: 0;");

    var updateHandler = function () {
      detailInfo.style.height = ""; // Make sure height values are as default before calculating the real heights            

      var detailInfoHeight = detailInfo.getBoundingClientRect().height;
      var containerHeight = container.getBoundingClientRect().height;

      if (detailInfoHeight > containerHeight) {
        var totalHeightDetail = detailInfoHeight - 250;
        adCol.style.height = totalHeightDetail + "px";
      } else {
        containerHeight += 30;
        adCol.style.height = containerHeight + "px";
        detailInfo.style.height = containerHeight + "px";
      }

      if (document.documentElement.clientWidth > 976) {
        adCol.style.display = "block";
      } else if (adCol.style.display === "block") {
        adCol.style.display = "none";
      }
    };

    try {
      var resultsObserver = new MutationObserver(updateHandler);
      addEventListener("orientationchange", updateHandler);
      addEventListener("resize", updateHandler);
      resultsObserver.observe(detailInfo, {
        subtree: true,
        childList: true
      });
    } catch (e) {
      setInterval(updateHandler, 3000);
    }
    // The Height of the nhs_ResAdCol will change according to the height of the results
    // and the function above will be executed anytime the results change
  },

  getCaptionToDisplay: function (text) {
    var replacedText = text;
    var replaceObjetive = text.match(/\w:\w/i);

    if (replaceObjetive !== null)
      replacedText = text.replace(replaceObjetive[0], replaceObjetive[0][0] + ": " + replaceObjetive[0][2]);

    return replacedText;
  }
}

document.addEventListener("readystatechange", function () {
  if (document.readyState === "complete") {
    NHS.loadCss(document.getElementById("detailsXpNonCriticalCss").value);

    if (window.NewHomeSource.ElementToggler) {
      window.NewHomeSource.ElementToggler.Init();
    }

    if (window.NewHomeSource.CommunityAndNeighBorhoodHandler) {
      window.NewHomeSource.CommunityAndNeighBorhoodHandler.init();
    }

    if (window.NewHomeSource.InitialLoadModalHandler) {
      window.NewHomeSource.InitialLoadModalHandler.DisplayModal();
    }
  }
});

/*Show floating form when is collapse*/
var takeATourFloatingButton = document.querySelector("[data-take-tour]");
var floatingFormContainerHide = " ";
if (takeATourFloatingButton) {
  takeATourFloatingButton.addEventListener("click", function () {
    floatingFormContainerHide = document.querySelector("[data-floating-form-container]");
    if (floatingFormContainerHide) {
      floatingFormContainerHide.classList.remove("minimize");
    }
  });
}

(function () {
  const trustBuilderReviewsSection = document.querySelector('[data-detail-reviews-section]');
  const builderSection = document.getElementById('builderInfoSection');

  if (trustBuilderReviewsSection && builderSection) {
    trustBuilderReviewsSection.addEventListener('touchend', function (event) {
      event.preventDefault();
      builderSection.scrollIntoView();
    });
  }
}());